import { Inbox } from 'lucide-react';
import { EmptyState } from '@/shared/components/empty-state';
import { Skeleton } from '@/shared/ui/skeleton';
import type { MgmReferralRow } from '../model/types';
import { MgmReferralCard } from './mgm-referral-card';

/** Lista simples de indicações (aba do lead) — mesmo card da página de Indique e ganhe. */
export function MgmReferralList({
  rows,
  loading,
  idPassbook,
  onOpen,
  hideReferrer,
  emptyDescription,
}: {
  rows: MgmReferralRow[];
  loading?: boolean;
  idPassbook: string;
  onOpen: (id: string) => void;
  hideReferrer?: boolean;
  emptyDescription?: string;
}) {
  if (loading) {
    return (
      <div className="space-y-3">
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} className="h-[72px] rounded-2xl" />
        ))}
      </div>
    );
  }
  if (rows.length === 0) {
    return <EmptyState icon={Inbox} title="Nenhuma indicação ainda" description={emptyDescription} />;
  }
  return (
    <ul className="space-y-2.5">
      {rows.map((row, i) => (
        <li key={row.id}>
          <MgmReferralCard referral={row} index={i} idPassbook={idPassbook} onOpen={onOpen} hideReferrer={hideReferrer} />
        </li>
      ))}
    </ul>
  );
}
